import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/services" element={<Services data-id="element-6" />} data-id="element-5" />
          <Route path="/services/:id" element={<ServiceDetail data-id="element-8" />} data-id="element-7" />
          <Route path="/contact" element={<Contact data-id="element-10" />} data-id="element-9" />
          <Route path="/about" element={<About data-id="element-12" />} data-id="element-11" />
        </Routes>
      </Layout>
    </Router>;
}